import { render, staticRenderFns } from "./ToznyKeyValue.vue?vue&type=template&id=627c2116&"
import script from "./ToznyKeyValue.vue?vue&type=script&lang=js&"
export * from "./ToznyKeyValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports